export default __webpack_public_path__ + "static/media/etacCerfThumbnail.d88b8d7c.jpg";